import { Button } from '@ps-design-system/components/Button';
import MinusIcon from '@ps-design-system/icons/Minus/Minus16';
import PlusIcon from '@ps-design-system/icons/Plus/Plus16';
import get from 'lodash/get';
import React from 'react';
import { Field, change } from 'redux-form';
import NumberField from '../../../app-main/components/reduxForms/fields/NumberField/NumberField';
import { CATERING_PACKAGE_FORM } from '../../../app-main/components/reduxForms/constants/formNames';

export const CateringAddOnCounterField = ({
  addOn,
  counter,
  formValues,
  dispatch
}) => {
  const fieldName = `addOns.${addOn.id}.${counter.name}`;
  const currentValue = +get(formValues, fieldName, 0);

  const handleQuantityStep = async (quantity, fieldName) => {
    const currentCount = +get(formValues, fieldName, 0);
    const newCount = currentCount + quantity;
    await dispatch(change(CATERING_PACKAGE_FORM, fieldName, newCount));
  };

  return (
    <div className="flex middle">
      <div className="catering-addons-counter">
        <Button
          iconOnly={true}
          variant="outline-1"
          appearance="white"
          onClick={() => handleQuantityStep(-1, fieldName)}
          disabled={currentValue === 0}
        >
          <MinusIcon />
        </Button>
        <Field
          name={fieldName}
          value={get(formValues, fieldName, '0')}
          component={NumberField}
          placeholder="0"
          attributes={{ min: 0 }}
        />
        <Button
          iconOnly={true}
          variant="outline-1"
          appearance="white"
          onClick={() => handleQuantityStep(1, fieldName)}
        >
          <PlusIcon />
        </Button>
      </div>
      <p className="no-margin margin-lg-left">{counter.name}</p>
    </div>
  );
};
